import fr from './fr/fr'
import en from './en/en'
import es from './es/es'
import ro from './ro/ro'
import ch from './en/en'

export default {
  fr: fr,
  en: en,
  es: es,
  ro: ro,
  ch: ch,
}



// WEBPACK FOOTER //
// ./src/translations/lang.js